import { useJuzgadosStore } from "@/store/Pinia/useJuzgadosStore";
import { useUfisStore } from "@/store/Pinia/useUfisStore";
import { usePersonalFiscalStore } from "@/store/Pinia/usePersonalFiscalStore";
import { useModusOperandiStore } from "@/store/Pinia/useModusOperandiStore";
import { useSitioStore } from "@/store/Pinia/useSitioStore";
import { useArticulosStore } from "@/store/Pinia/useArticulosStore";
import { useCausaCaratulaStore } from "@/store/Pinia/useCausaCaratulaStore";
import { useDelitosStore } from "@/store/Pinia/useDelitosStore";

export function useCatalogs() {
  const preloadCatalogs = async (typeActuation) => {
    const isUFI =
      typeActuation?.includes("unidades fiscales") || typeActuation?.includes("ufi");

    const juzgadosStore = useJuzgadosStore();
    const ufisStore = useUfisStore();
    const personalFiscalStore = usePersonalFiscalStore();
    const modusOperandiStore = useModusOperandiStore();
    const sitioStore = useSitioStore();
    const articulosStore = useArticulosStore();
    const causaCaratulaStore = useCausaCaratulaStore();
    const delitosStore = useDelitosStore();

    const promises = [
      juzgadosStore.setAllJuzgados(),
      ufisStore.setUfis(),
      personalFiscalStore.setFiscales(),
      personalFiscalStore.setAyudantesFiscales(),
      modusOperandiStore.setModusOperandi(),
      sitioStore.setSitios(),
      articulosStore.setAllArticulos(),
    ];

    if (isUFI) {
      promises.push(delitosStore.setDelitos());
    } else {
      promises.push(causaCaratulaStore.setCausasCaratulas());
    }

    try {
      await Promise.all(promises);
    } catch (e) {
      console.error("Error al cargar catálogos:", e);
    }
  };

  return { preloadCatalogs };
}
